export default function RequiredFlag(): JSX.Element {
  return <span className="kup-label-required-flag">*</span>;
}
